module.exports = __webpack_public_path__ + "img/mac.dbb2947c.svg";